import React from 'react'

const About = () => {
  return (
    <div className='About'>
      <div className='aboutHeading'>
        <h1>About NoteFlow</h1>
      </div>
      <div className="para">
        <p>
        📝 Welcome to NoteFlow, your go-to digital notebook for capturing ideas, tasks, and inspiration on the go.
        </p>
        <h2>
        🚀 Our Mission:
        </h2>
        <p>
        NoteFlow was born out of a passion for simplifying note-taking. Our mission is to empower you to organize your thoughts effortlessly and boost your productivity.
        </p>
      </div>
    </div>
  )
}

export default About